import React, { Component } from "react";
import { connect } from "react-redux";
import {
  feedbackWatchOn,
  feedbackWatchOff
} from "../../actions/feedbackActions";

import ClassCodes from "../classCodes";
import List from "./List";
import VotingOpen from "../debate/VotingOpen";

import _ from "lodash";

class Awards extends Component {
  componentDidMount() {
    this.props.feedbackWatchOn();
  }

  componentWillUnmount() {
    this.props.feedbackWatchOff();
  }

  render() {
    const { cCode } = this.props.location.params || {};
    const { users } = this.props;
    return (
      <>
        <ClassCodes />
        {cCode && !_.isEmpty(users) && (
          <>
            <List />
            <VotingOpen votingType={"feedback"} />

            {/* NEED TO DEVELOP :: SHOW VISUAL RESULT */}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location
});

export default connect(
  mapStateToProps,
  { feedbackWatchOn, feedbackWatchOff }
)(Awards);
